import React from 'react'
import { type AppBottomBarIconProps } from '../types'

export const CalendarSVGIcon: React.FC<AppBottomBarIconProps> = ({
  isActive
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_607_1203)">
      <path
        d="M10.417 2.9165V5.5835H21.583V2.9165H23.75V5.5835H25.333C26.6615 5.5835 27.7498 6.67106 27.75 7.99951V26.6665C27.75 27.9951 26.6616 29.0835 25.333 29.0835H6.66699C5.32588 29.0835 4.25 27.9959 4.25 26.6665L4.26367 8.00049V7.99951C4.26385 6.66861 5.32762 5.5835 6.66699 5.5835H8.25V2.9165H10.417ZM6.41699 26.9165H25.583V13.0835H6.41699V26.9165ZM22.417 14.9165V17.0835H20.25V14.9165H22.417ZM17.083 14.9165V17.0835H14.917V14.9165H17.083ZM11.75 14.9165V17.0835H9.58301V14.9165H11.75ZM6.41699 10.9165H25.583V7.74951H6.41699V10.9165Z"
        fill={isActive ? '#1B294C' : '#93979F'}
        stroke="#F5F5F5"
        strokeWidth="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_607_1203">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
